export default {
  "Pravidla pro předpoklady na celý měsíc":
    "Pravidla pro předpoklady na celý měsíc",
  "Nové pravidlo": "Nové pravidlo",
  "Editovat pravidlo": "Editovat pravidlo",
  "Uložit pravidlo": "Uložit pravidlo",
  "Smazat pravidlo": "Smazat pravidlo",
  "Import EAN/EIC": "Import EAN/EIC",
  Komodita: "Komodita",
  Elektřina: "Elektřina",
  Plyn: "Plyn",
  "Status OPM": "Status OPM",
  "Platnost pravidla od": "Platnost pravidla od",
  "Platnost pravidla do": "Platnost pravidla do",
  "Typ měřidla": "Typ měřidla",
  "Spotřeba od": "Spotřeba od",
  "MWh/rok": "MWh/rok",
  "Spotřeba do": "Spotřeba do",
  "Alert poslat na e-mail": "Alert poslat na e-mail",
  "Předpoklad poslat na e-mail": "Předpoklad poslat na e-mail",
  "Zobrazit seznam OPM v novém okně": "Zobrazit seznam OPM v novém okně",
  "Všechny OPM": "Všechny OPM",
  "Active OPMs": "Aktivní OPM",
  active: "aktivni",
  inactive: "neaktivni",
  "Inactive OPMs": "Neaktivní OPM",
  "Zrusene OPM": "Zrusene OPM",
  "Pravidla pro aktualizaci měsíčního předpokladu":
    "Pravidla pro aktualizaci měsíčního předpokladu",
  Perioda: "Perioda",
  "První den periody": "První den periody",
  "Blokovat pravidlo - počet dnů na začátku měsíce":
    "Blokovat pravidlo - počet dnů na začátku měsíce",
  "1 deň": "1 deň",
  "7 dní": "7 dní",
  pondělí: "pondělí",
  úterý: "úterý",
  středa: "středa",
  čtvrtek: "čtvrtek",
  pátek: "pátek",
  sobota: "sobota",
  neděle: "neděle",
  "Uložené": "Uložené",
  "Zkopírovat měsíční předpoklad": "Zkopírovat měsíční předpoklad",
  "Nastavení pravidel pro odhad spotřeby vždy na celý kalendářní měsíc.":  "Nastavení pravidel pro odhad spotřeby vždy na celý kalendářní měsíc.",
  "Nastavení pravidel pro upřesňování měsíčního odhadu spotřeby.":  "Nastavení pravidel pro upřesňování měsíčního odhadu spotřeby.",
  "Perioda upřesňování odhadu": "Perioda upřesňování odhadu",
  "import-ean-eic": "Box pro vložení kódů konkrétních odběrných míst. Když tento box vyplníte, tak některé další boxy budou nefunkční (boxy ",
  "import-ean-eic-items": "Komodita, Status OPM, Typ měřidla, Spotřeba od, Spotřeba do",
  "state-opm": "Aktivní OPM jsou OPM na kterých není demontováno měřidlo, nebo není přerušená dodávka .",
  "rule-validity-from": "Datum, Od kdy chcete aby toto pravidlo bylo účinné.",
  "rule-validity-to": "Datum, Do kdy chcete aby toto pravidlo bylo účinné.",
  "consuption-from": "Objem roční spotřeby energie na odběrném místě v MWh/rok. Pravidlo bude platit pouze pro ta odběrná místa, které mají plánovanou/odhadovanou roční spotřebu energie rovnou, nebo vyšší, než je hodnota v boxu.",
  "consuption-to": "Objem roční spotřeby energie na odběrném místě v MWh/rok. Pravidlo bude platit pouze pro ta odběrná místa, která mají plánovanou/odhadovanou roční spořebu energie rovnou, nebo menší, než je hodnota v boxu.",
  "alert-email": "E-mail adresa/adresy osoby/osob u dodavatele energie (pokud do termínu odběratel neodešle dodavateli předpoklad spotřeby energie na následující období, tak systém o tom odešle upozornění na uvedené adresy dodavatele). Oddělovač mezi e-mailovými adresami je čárka nebo středník.",
  "forecast-email": "E-mail adresa/adresy osoby/osob u dodavatele energie, na kterou/které bude systém odesílat předpoklady spotřeby energie tak, jak je odběratel nahrál do systému. Oddělovač mezi e-mailovými adresami je čárka nebo středník.",
  "show-opms-in-new-window": "Zobrazit seznam OPM pro tento měsíční odhad spotřeby (v novém okně)",
  "import-ean-eic-weekly": "Podle tohoto pravidla bude odběratel upřesňovat měsíční odhad spotřeby 1x za týden. Do boxu můžete vložit pouze ty kódy odběrných míst, pro které platí nadřazené pravidlo pro odhad spotřeby na celý kalendářní měsíc.",
  "period-weekly": "Perioda pravidelného upřesňování měsíčního odhadu spotřeby. Předdefinované období je 1x za týden.",
  "period-first-day-weekly": "Z praktických důvodů je začátek periody nastaven na čtvrtek - aby měl dodavatel k dispozici nejpozději ve středu informaci na období následujících 7 dní, které začíná čtvrtkem.",
  "block-rule-weekly": "Možnost na několik dní (na začátku každého měsíce) zablokovat pravidlo upřesňování měsíčního odhadu spotřeby, aby tak z důvodu kalendáře nenastala situace, že odběratel bude mít povinnost nahlásit měsíční předpoklad spotřeby na celý kalendářní měsíc a hned na druhý den mu systém pošle upozornění, aby nahlásil upřesnění.",
  "show-opms-in-new-window-weekly": "Zobrazit seznam OPM pro toto upřesňování měsíčního odhadu spotřeby (v novém okně)",
  "inactivity-logout" : "Byli jste automaticky odhlášeni ze systému z důvodu neaktivity.",
  "Kmenová data OPM pro odhad spotřeby" : "Kmenová data OPM pro odhad spotřeby",
  "Kmenová data export": "Kmenová data export",
  "Kmenová data import": "Kmenová data import",

  "Měření": "Měření",
  "Dátum od": "Dátum od",
  "Dátum do": "Dátum do",
  "Elektrická energie": "Elektrická energie",
  "Zemní plyn": "Zemní plyn",
  "Typ měření": "Typ měření",
  "Druh OPM": "Druh OPM",
  "Výroba + Spotřeba": "Výroba + Spotřeba",
  "Výroba": "Výroba",
  "Spotřeba": "Spotřeba",
  "Typ dát": "Typ dát",
  "Korigované + Normalizované": "Korigované + Normalizované",
  "Normalizované": "Normalizované",
  "Korigované": "Korigované",
  "1 hodina": "1 hodina",
  "Den": "Den",
  "15 minut": "15 minut",
  "Poskytovatel měřených dat": "Poskytovatel měřených dat",
  "-- Všichni --": "-- Všichni --",
  "Primární dodavatel": "Primární dodavatel",
  "Jazyk": "Jazyk",
  "Česky": "Česky",
  "English": "English",
  "Zadejte seznam odběrných míst": "Zadejte seznam odběrných míst",
  "Export": "Export",
  "Odběrná místa": "Odběrná místa",
  "Odhlásit": "Odhlásit",
  "Aktuální počet úkolů:": "Aktuální počet úkolů:"
};



// WEBPACK FOOTER //
// ./src/Translate/cz.js